import { Box, Fade } from '@mui/material'
import React from 'react'
import { connect } from 'react-redux'
import { MessageContacts } from 'components/messages'
import ChatBox from 'components/messages/chat-box'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as MessageOperations,
  operations as messageOperations
} from 'states/dux/message/operations'
import { Payload as MessagePayload } from 'states/dux/message/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import {
  Operations as UserOperations,
  operations as userOperations
} from 'states/dux/user/operations'
import { Payload as UserPayload } from 'states/dux/user/types'
import State from 'states/types'
import { NivosMessage } from 'types/nivos-message'
import { NivosPublicUser, NivosUserGroup } from 'types/user'
import {
  get,
  mapOperationsToDispatchProps,
  objectifyDateStringFields,
  trusty
} from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
  user: UserPayload
  message: MessagePayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
    user: UserOperations
    message: MessageOperations
  }
}

type AppProps = StateProps & DispatchProps

const MessagesFC: React.FC<any> = (props: AppProps) => {
  const { user, message, operations } = props
  const [currentSelected, setCurrentSelected] = React.useState<
  NivosPublicUser | NivosUserGroup
  >()

  const _routeSetSelection = (data: NivosPublicUser | NivosUserGroup): void => {
    if ('fullName' in data) {
      _setMessagesForSelectedContact(data.id)
    }
    if ('name' in data) {
      _setMessagesForSelectedGroupChat(data.id)
    }
  }

  const _setMessagesForSelectedContact = (contactId: number): void => {
    void get(`/message/get_messages/${contactId}/`).then(data => {
      const parsedData: NivosMessage[] = data.map((item: object) =>
        objectifyDateStringFields(item)
      )
      operations.message.set(parsedData)
    })
  }

  const _setMessagesForSelectedGroupChat = (groupId: number): void => {
    void get(`/message/get_group_messages/${groupId}/`).then(data => {
      const parsedData: NivosMessage[] = data.map((item: object) =>
        objectifyDateStringFields(item)
      )
      operations.message.set(parsedData)
    })
  }

  React.useEffect(() => {
    if (trusty(user.authenticated) && user.contactList.length > 0) {
      setCurrentSelected(user.contactList[0])
    }
  }, [user])

  React.useEffect(() => {
    if (currentSelected !== undefined) _routeSetSelection(currentSelected)
  }, [currentSelected])

  return (
    <Fade in={true} timeout={1000}>
      <Box
        display={'flex'}
        width={1}
        minHeight={'84.5vh'}
        sx={{ transition: '.5s' }}
      >
        <Box width={0.3} maxWidth={400} height={1}>
          <MessageContacts
            selectedContact={currentSelected}
            setSelectedContact={setCurrentSelected}
          />
        </Box>
        <Box flexGrow={1} height={1}>
          {currentSelected !== undefined && (
            <ChatBox
              kausap={currentSelected}
              messages={message.data}
              isaGroupChat={'name' in currentSelected}
              fillSpace={true}
            />
          )}
        </Box>
      </Box>
    </Fade>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout,
    user: state.user,
    message: state.message
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations,
  user: userOperations,
  message: messageOperations
})

const Messages = connect(mapStateToProps, mapDispatchToProps)(MessagesFC)

export default Messages
